module.exports = __webpack_public_path__ + "img/code.d83c99ab.png";